module.exports = __webpack_public_path__ + "img/tel.b18bb254.jpg";